import { styled } from "@mui/material/styles";

export const SvgIconWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
